import { login, loginDg, getInfo, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Notification } from 'element-ui'
const user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false,
    menuList: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    },
    SET_MENU_LIST: (state, menuList) => {
      state.menuList = menuList
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if (res.code === 200) {
            setToken(res.data.token, rememberMe)
            commit('SET_TOKEN', res.data.token)
            // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
            commit('SET_LOAD_MENUS', true)
          } else {
            Notification.error({
              title: '登录失败',
              message: res.msg
            })
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    LoginDg({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        loginDg(userInfo).then(res => {
          if (res.code === 200) {
            setToken(res.data.token, rememberMe)
            commit('SET_TOKEN', res.data.token)
            // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
            commit('SET_LOAD_MENUS', true)
          } else {
            Notification.error({
              title: '登录失败',
              message: res.msg
            })
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          setUserInfo(res.data, commit)
          commit('SET_MENU_LIST', res.data.menuList)
          resolve(0)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          logOut(commit)
          resolve()
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },

    updateLoadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    }
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
}

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  //   if (res.permissionList.length === 0) {
  //     commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  //   } else {
  //     commit('SET_ROLES', res.permissionList)
  //   }
  commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  commit('SET_USER', res)
}

export default user
